import React from 'react';

const DownloadIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      fill={props.fill ? props.fill : '#437EF7'}
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 24 24"
      className={`${
        props.className ? props.className : 'fill-blue hover:fill-white'
      }`}
    >
      <path d="M12 16l-4-4h3V8h2v4h3l-4 4zm-8 3h16c1.104 0 2-.896 2-2s-.896-2-2-2H4c-1.104 0-2 .896-2 2s.896 2 2 2z" />
    </svg>
  );
};

export default DownloadIcon;
